export default __webpack_public_path__ + "static/media/GraftCafe-4.5ca03a7f.jpg";